import axios from 'axios'
import humps from 'humps'

// TODO: transform date fields on request and response
// try lodash deep
// _.deepMapValues(object, function(value, path) {
//   if (_.includes(dateFields, path)) {
//     return moment(value).format("YYYY-MM-DD");
//   } else {
//     return value
//   }
// });

var requestConfig = {
  transformRequest: [function (data, headers) {
    if (data) {
      var decamelizedData = humps.decamelizeKeys(data)
      headers['Content-Type'] = 'application/json;charset=utf-8';
      return JSON.stringify(decamelizedData)
    }
  }],
  transformResponse: [function (data) {
    return humps.camelizeKeys(JSON.parse(data))
  }]

}
var get = function(url) {
  return axios.get(url, requestConfig)
}

var post = function(url, params) {
  return axios.post(url, params, requestConfig)
}

export { get, post }
